import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import {
  OrganisationState,
  OrganisationStateModel,
} from '@app/finxone-web-frontend/app/lib/state/organisation.state';
import {
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  UiZoneWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { FormActionTypeEnum } from 'libs/shared/enums/form-action.enum';
import { debounceTime, distinctUntilChanged, map, Observable, takeUntil } from 'rxjs';
import { FormSubmitter } from '../form-widgets/form-submitter/form-submitter.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-company-name-widget',
  templateUrl: './company-name-widget.component.html',
})
export class CompanyNameWidgetComponent extends FormSubmitter implements OnInit {
  public widgetConfig: UiZoneWidgetConfig;
  @Select(OrganisationState.getOrganisation)
  public organisation$: Observable<OrganisationStateModel>;
  public formGroup: FormGroup<{}>;
  public organisationData: OrganisationStateModel;
  public selectCompanyNameForm: FormGroup<{}>;
  public formStateData: string;
  constructor(
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private configService: ConfigService,
    protected override store: Store,
  ) {
    super(store);
    if (this.dataIn != undefined && this.dataIn != null) {
      this.widgetConfig = this.dataIn.widgetConfig;
    }
    this.organisation$.pipe(takeUntil(this.destroy$)).subscribe((organisation) => {
      this.organisationData = organisation;
    });
  }

  ngOnInit() {
    this.buildForm();
  }

  public buildForm() {
    this.getFormActionData();
    this.formGroup = new FormGroup<any>({});
    for (const field of this.widgetConfig.attributes['field_attributes']) {
      this.formGroup.addControl(field.name, new FormControl('', [Validators.required]));
    }
    this.selectCompanyNameForm = this.formGroup;

    //When company name changes then it is getting updated in formstate with the key "organisation_companyName"
    this.selectCompanyNameForm.valueChanges
      .pipe(takeUntil(this.destroy$), debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        if (this.selectCompanyNameForm.valid) this.onSubmit();
      });

    const initialValue = this.formStateData ?? this.organisationData?.name ?? '';
    this.selectCompanyNameForm.patchValue({ organisation_companyName: initialValue }, { emitEvent: true });
  }

  public getFormActionData() {
    this.getFormActionDataWithId(FormActionTypeEnum.KYB_DETAILS)
      .pipe(
        takeUntil(this.destroy$),
        map((formActionData) => {
          this.formStateData = formActionData?.['formData'].organisation_companyName;
        }),
      )
      .subscribe();
  }

  public onSubmit() {
    if (this.selectCompanyNameForm.valid) {
      const formObject = this.selectCompanyNameForm.value;
      this.store.dispatch(
        new UpdateFormDataActionWithId(
          {
            ...formObject,
          },
          FormActionTypeEnum.KYB_DETAILS,
        ),
      );
    }
  }
}
